export default __webpack_public_path__ + "static/media/phone.7f8451c2.svg";